import { ApiError, apiFetch, jsonOpts, parseJson } from "./client";
import type { ChangePasswordIn, LoginInput, User } from "./types";

/** Stable codes from `POST /api/auth/password` error bodies. */
export const CURRENT_PASSWORD_INCORRECT = "current_password_incorrect";
export const TOO_MANY_ATTEMPTS = "too_many_attempts";

export function isWrongCurrentPassword(error: unknown): error is ApiError {
  return error instanceof ApiError && error.code === CURRENT_PASSWORD_INCORRECT;
}

/** 401 is the documented "no session" answer here, not a failure. */
export async function fetchCurrentUser(): Promise<User | null> {
  const res = await apiFetch("/api/auth/me");
  if (res.status === 401) return null;
  return parseJson<User>(res);
}

export async function login(input: LoginInput): Promise<User> {
  const res = await apiFetch("/api/auth/login", {
    ...jsonOpts,
    method: "POST",
    body: JSON.stringify(input),
  });
  return parseJson<User>(res);
}

export async function changePassword(input: ChangePasswordIn): Promise<void> {
  await parseJson<void>(
    await apiFetch("/api/auth/password", {
      ...jsonOpts,
      method: "POST",
      body: JSON.stringify(input),
    })
  );
}

export async function logout(): Promise<void> {
  await parseJson<void>(
    await apiFetch("/api/auth/logout", {
      method: "POST",
    })
  );
}
